import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import 'aos/dist/aos.css'; // Ensure you have AOS library installed and imported
import AOS from 'aos';
import AuthService from '../components/AuthService';

const pageContent = {
  "/": {
    title: "Courses",
    description: "Please Chose the course you want to start below "
  },
  "/couses": {
    title: "Courses",
    description: "Explore our wide range of courses designed to help you gain new skills and advance your career. Our courses are taught by experienced instructors and cover a variety of subjects to meet your educational needs."
  },
  "/about": {
    title: "About Us",
    description: "We are committed to providing the best service. Our team is dedicated to your success and satisfaction."
  },
  "/contact": {
    title: "Contact Us",
    description: "Feel free to reach out to us with any inquiries. We're here to help you with whatever you need."
  },
  "/services": {
    title: "Our Services",
    description: "Hose Consults Uganda Ltd offers other services below."
  },
  "/team": {
    title: "Our Team",
    description: "We are honest and truthful in all our actions at Hose Consults Uganda Limited."
  },
  "/blog": {
    title: "Recent Blog Posts",
    description: "OSH   ENVIRONMENT  QUALITY SECURITY    HR CONSULTANCY"
  },
  "/course-details/1": {
    title: "Course Details",
    description: "Fire Course still under constraction"
  },
  "/course-details/2": {
    title: "Course Details",
    description: "Comprehensive First Aid COURSES"
  },
  "/activatec": {
    title: "Activate ",
    description: "Please go ahead to activate your Courses"
  },
  "/course-details/3": {
    title: "Course Details",
    description: "under constraction"
  },
  "/loginall": {
    title: "LOGIN",
    description: "Login to your account !"
  },
  // Add more paths as needed
};

function Heroall() {
  useEffect(() => {
    AOS.init();
  }, []);

  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  const currentPath = `/${pathnames.join('/')}`;
  const { title, description } = pageContent[currentPath] || { title: "Page Not Found", description: "The page you are looking for does not exist." };

  const currentUser = AuthService.getCurrentUser();
  const currentUserName = AuthService.getCurrentUserName();
  return (
    <div className="page-title" data-aos="fade">
      <div className="heading">
        <div className="container">
          <div className="row d-flex justify-content-center text-center">
            <div className="col-lg-8">
              
              {currentUser? <h1>You Are Wellcome <span style={{textDecoration:'underline'}}>{currentUserName}</span></h1>:<h1>{title}</h1> }
              <p className="mb-0">
                {description}
              </p>
              {currentUser? <h5>THANK YOU </h5>:'' }
            </div>
          </div>
        </div>
      </div>
      <nav className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            {pathnames.map((value, index) => {
              const to = `/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;
              return isLast ? (
                <li key={to} className="current">{value}</li>
              ) : (
                <li key={to}><Link to={to}>{value}</Link></li>
              );
            })}
          </ol>
        </div>
      </nav>
    </div>
  );
}

export default Heroall;
